export default "__VITE_PUBLIC_ASSET__aef168e2__"